<div class="one-column" *ngIf="organisationService.activeItem">
    <h1 style="font-weight: 600;">Mitglieder verwalten</h1>
    <div class="table max-width-setting-content">
        <div class="row border">
            <div>
                <p class="name-field"><b>Mitglieder</b></p>
            </div>
            <div>
                <p class="name-field"><b>Rolle</b></p>
            </div>
        </div>
        <div *ngFor="
                let member of organisationService.activeItem.organisationMembers
                    | confirmedMembers
            " class="row">
            <div class="flx-center">
                <p class="name-field">{{ member.userName }}</p>
            </div>
            <div *ngIf="isCurrentUserAdmin()" class="flx-center">
                <mat-form-field appearance="outline" class="role-selector" subscriptSizing="dynamic">
                    <mat-select [value]="member.role" (selectionChange)="
                            changeMemberRole($event, member.userId)
                        ">
                        <mat-option [value]="'ADMIN'">Administrator</mat-option>
                        <mat-option [value]="'USER'">Benutzer</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="!isCurrentUserAdmin()" class="flx-center">
                <p>{{ getRole(member.role) }}</p>
            </div>
            <div *ngIf="isCurrentUserAdmin()" class="flx-center">
                <red-cross-button (click)="removeMember(member)" [text]="'Entfernen'"></red-cross-button>
            </div>
        </div>
    </div>

    <button *ngIf="isCurrentUserAdmin()" matButton="elevated" class="green-confirm"
        (click)="updateOrganisationMembers()">
        Alle Änderungen speichern
    </button>
    <br />
    <br />
    <br />

    <div *ngIf="isCurrentUserAdmin()" class="flx-start">
        <app-hexagon-button-text-icon [text]="'Offene Mitglieder'" [icon]="'/assets/img/icons/svg/add_org.svg'"
            (click)="openMembersModeToggle()">
        </app-hexagon-button-text-icon>
    </div>

    <div *ngIf="openMembersMode">
        <div class="table">
            <div class="request-row">
                <div>
                    <p><b>Offene Anfragen</b></p>
                </div>
                <div>
                    <p><b>Rolle</b></p>
                </div>
                <div></div>
            </div>
            <div class="request-row" *ngFor="
                    let member of organisationService.activeItem
                        .organisationMembers | adminConfirmationPending
                ">
                <div>
                    <p>{{ member.userName }}</p>
                </div>
                <div>
                    <p>
                        {{ getRole(member.role) }}
                    </p>
                </div>
                <div>
                    <button matButton="elevated" class="acceptButton" (click)="acceptMemberQuery(member.userId)">
                        <mat-icon aria-label="Einladung Annehmen" aria-label="Annehmen">add</mat-icon>
                    </button>
                </div>
                <div>
                    <button class="remove-btn" (click)="declineMemberQuery(member.userId)"
                        aria-label="Anfrage entfernen">
                    </button>
                </div>
            </div>
        </div> -->
        <div class="table max-width-setting-content">
            <div class="row border">
                <div>
                    <p class="name-field"><b>Offene Einladungen</b></p>
                </div>
                <div>
                    <p class="name-field"><b>Rolle</b></p>
                </div>
                <div></div>
            </div>
            <div class="row" *ngFor="
                    let member of organisationService.activeItem
                        .organisationMembers | userConfirmationPending
                ">
                <div>
                    <p class="name-field">{{ member.userName }}</p>
                </div>
                <div>
                    <p class="name-field">
                        {{ getRole(member.role) }}
                    </p>
                </div>
                <div class="flx-center">
                    <red-cross-button (click)="removeMember(member)" [text]="'Entfernen'"></red-cross-button>
                </div>
            </div>
        </div>
    </div>
    <br *ngIf="openMembersMode || inviteMemberMode" />

    <div *ngIf="isCurrentUserAdmin()" class="flx-start">
        <app-hexagon-button-text-icon [text]="'Neue Mitglieder einladen'"
            [icon]="'/assets/img/icons/svg/add_member.svg'" (click)="inviteMembersModeToggle()">
        </app-hexagon-button-text-icon>
    </div>

    <div *ngIf="inviteMemberMode" class="max-width-setting-content">
        <div class="invite-input-container">
            <div class="columns-50-50 invite-input-fields">
                <mat-form-field>
                    <mat-label>E-Mail</mat-label>
                    <input type="email" matInput placeholder="E-Mail des Benutzers*" [(ngModel)]="userToInvite.userName"
                        pattern="[^@]+@[^@]+\.[^@]+" />
                    <mat-hint>Bitte eine valide E-Mail angeben.</mat-hint>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Rolle</mat-label>
                    <mat-select [(ngModel)]="userToInvite.role">
                        <mat-option [value]="'ADMIN'">Administrator</mat-option>
                        <mat-option [value]="'USER'">Benutzer</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <hexagon [outerColor]="'var(--app-surface)'" [middleColor]="'var(--app-primary)'" [icon]="'plus'"
                [hover]="'true'" (click)="addOneEntry()" class="add-button"></hexagon>
        </div>
        <table style="width: 100%;" mat-table [dataSource]="dataSource" class="invite-table" *ngIf="getInvites()">
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef class="header-table">
                    E-Mail
                </th>
                <td mat-cell *matCellDef="let user" class="name-column-table column-table">
                    {{ user.userName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef class="header-table">
                    Rolle
                </th>
                <td mat-cell *matCellDef="let user" class="role-column-table column-table">
                    {{ getRole(user.role) }}
                </td>
            </ng-container>
            <ng-container matColumnDef="remove">
                <th mat-header-cell *matHeaderCellDef class="header-table"></th>
                <td mat-cell *matCellDef="let user" class="column-table">
                    <red-cross-button (click)="removeEntry(user)"></red-cross-button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
        </table>
        <div *ngIf="getInvites()"></div>
        <div class="columns-50-50 width-btn">
            <button matButton="elevated" color="warn" type="button" (click)="inviteMembersModeToggle()">
                Abbrechen
            </button>
            <button matButton="elevated" class="green-confirm" (click)="inviteMembersConfirm()"
                [disabled]="!getInvites()">
                Einladen
            </button>
        </div>
    </div>

    <!-- <div *ngIf="isCurrentUserAdmin()">
        <app-hexagon-button-text-icon
            [text]="'Organisation überschreiben'"
            [icon]="'/assets/img/icons/Organisation_hinzufuegen.png'"
            (click)="transmitMembersModeToggle()"
        >
        </app-hexagon-button-text-icon>
    </div>

    <div *ngIf="transmitMemberMode" class="columns-50-50">
        <mat-form-field>
            <input
                matInput
                placeholder="E-Mail des Benutzers"
                [(ngModel)]="userToInvite.userName"
            />
        </mat-form-field>
        <mat-form-field>
            <input matInput placeholder="Nachricht" [(ngModel)]="message" />
        </mat-form-field>
        <div *ngIf="enableSendBtn" class="columns-50-50">
            <button
                class="btn_green"
                mat-raised-button
                (click)="transmitConfirm()"
            >
                Senden
            </button>

            <button
                class="btn_red"
                mat-raised-button
                (click)="transmitMembersModeToggle()"
            >
                Abbrechen
            </button>
        </div>
        <div *ngIf="enableSendBtn" class="columns-50-50">
            <font size="3" class="text-primary">{{ messageTransmitResponse }}</font>
        </div>
    </div> -->


</div>
<div *ngIf="isLoading" class="loading-overlay-spinner">
    <mat-spinner></mat-spinner>
</div>